import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postCompanyUser,
  putCompanyUser,
  patchCompanyUser,
  deleteCompanyUser,
  resetPasswordCompanyUser
} from '@galo-monitor/services/apis/galoMonitorApi/resources/user'

import { CompanyUserActions, CompanyUserTypes } from './duckCompanyUser'

function* saveCompanyUser({
  companyUser,
  onSuccess = () => {},
  onError = () => {}
}) {
  try {
    yield call(companyUser.id ? putCompanyUser : postCompanyUser , companyUser)

    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyUserActions.companyUserError(err.message))
    yield call(onError, err)
  }
}

function* removeCompanyUser({ companyUser, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteCompanyUser, companyUser)
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyUserActions.companyUserError(err.message))
    yield call(onError, err)
  }
}

function* toggleActivateCompanyUser({ companyUser, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(patchCompanyUser, companyUser)
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyUserActions.companyUserError(err.message))
    yield call(onError, err)
  }
}

function* resetCompanyUserPassword({ userId, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(resetPasswordCompanyUser, userId)
    yield call(onSuccess)
  } catch (err) {
    yield put(CompanyUserActions.companyUserError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(CompanyUserTypes.SAVE_COMPANY_USER, saveCompanyUser),
  takeLatest(CompanyUserTypes.TOGGLE_ACTIVATE_COMPANY_USER, toggleActivateCompanyUser),
  takeLatest(CompanyUserTypes.REMOVE_COMPANY_USER, removeCompanyUser),
  takeLatest(CompanyUserTypes.RESET_COMPANY_USER_PASSWORD, resetCompanyUserPassword)
]
